<template>
    <div class="custom-ag-dropdown">
        <form-group>
            <md-select v-model="currentValue" @md-selected="optionSelected">
                <md-option key="all" value="All">All</md-option>
                <md-option v-if="includeBlank" key="blank" value="Blank">Blank</md-option>
                <md-option v-for="item in params.dropdownValues" :key="item" :value="item">
                    {{ item }}
                </md-option>
            </md-select>
        </form-group>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentValue: 'All',
            includeBlank: false
        };
    },
    beforeMount() {
        this.includeBlank = this.params.includeBlank === true;
    },
    methods: {
        optionSelected() {
            if (this.currentValue && this.currentValue === 'All') {
                this.params.parentFilterInstance((instance) => {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }

            if (this.currentValue && this.currentValue === 'Blank') {
                this.params.parentFilterInstance((instance) => {
                    instance.onFloatingFilterChanged('blank', null);
                });
                return;
            }

            this.params.parentFilterInstance((instance) => {
                instance.onFloatingFilterChanged('equals', this.currentValue);
            });
        },
        onParentModelChanged(parentModel) {
            // When the filter is empty we will receive a null value here

            if (!parentModel) {
                this.currentValue = 'All';
            } else if (parentModel.type === 'blank') {
                this.currentValue = 'Blank';
            } else {
                this.currentValue = parentModel.filter;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .md-input.md-select-value {
    padding-left: 8px;
    min-height: 32px;
    border-radius: 4px;
    border: 1px solid #dddddd;
    color: inherit !important;
}

.custom-ag-dropdown {
    align-items: center;
    display: flex;
    width: 100%;
}

.md-field:after {
    height: 0px;
}
</style>
